"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var MoreVertOutlined_1 = __importDefault(require("../Icon/icons/MoreVertOutlined"));
var ContextMenu_styles_1 = require("./ContextMenu-styles");
var ContextMenu = function (_a) {
    var className = _a.className, menuItems = _a.menuItems, initialOpen = _a.initialOpen, forceOpen = _a.forceOpen;
    var _b = React.useState(initialOpen), show = _b[0], setShow = _b[1];
    var component = React.useRef(null);
    var onMenuClick = function () {
        if (!forceOpen) {
            setShow(!show);
        }
    };
    React.useEffect(function () {
        setShow(forceOpen);
    }, [forceOpen]);
    React.useEffect(function () {
        var listener = function (event) {
            var _a;
            if (!((_a = component === null || component === void 0 ? void 0 : component.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setShow(false);
            }
        };
        if (show && !forceOpen) {
            document.addEventListener('click', listener);
        }
        else {
            document.removeEventListener('click', listener);
        }
        return function () { return document.removeEventListener('click', listener); };
    }, [forceOpen, show]);
    return (React.createElement(ContextMenu_styles_1.ContextMenuWrapper, { className: className, ref: component },
        React.createElement(ContextMenu_styles_1.ContextMenuTriggerWrapper, { onClick: onMenuClick },
            React.createElement(MoreVertOutlined_1.default, { color: show ? 'DIGITAL_DARK_GREY' : 'BRAND_PREMIUM_GREY' })),
        show && React.createElement(MenuItems, __assign({}, (!forceOpen && { closeMenu: function () { return setShow(false); } }), { items: menuItems }))));
};
exports.default = ContextMenu;
var MenuItems = function (_a) {
    var closeMenu = _a.closeMenu, items = _a.items;
    var menuElement = React.useRef(null);
    var _b = React.useState(false), alignRight = _b[0], setAlignRight = _b[1];
    React.useEffect(function () {
        var current = menuElement.current;
        if (current) {
            var bounding = current.getBoundingClientRect();
            if (bounding.x + current.offsetWidth > window.innerWidth) {
                setAlignRight(true);
            }
        }
    }, [menuElement]);
    return (React.createElement(ContextMenu_styles_1.ContextMenuItemsWrapper, { ref: menuElement, alignRightEdge: alignRight }, items === null || items === void 0 ? void 0 : items.map(function (item, key) {
        return (React.createElement(ContextMenu_styles_1.ContextMenuItem, { "$clickable": Boolean(item.onClick), key: key, onClick: function () {
                if (item.onClick) {
                    closeMenu === null || closeMenu === void 0 ? void 0 : closeMenu();
                    item.onClick();
                }
            } }, item.text));
    })));
};
